import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Ensure CSS files are loaded
import './Pages/LogUp/LogUp.css';

// Dev: enable mock API in development builds (can be overridden in console)
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  try {
    window.USE_MOCK = true;
    // Persist for future reloads in this browser
    localStorage.setItem('USE_MOCK', 'true');
  } catch (e) {
    // ignore in non-browser context
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
